module.exports = __webpack_public_path__ + "img/aps-logo.6934222d.png";